import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Navbar } from "../../../components/Navbar/Navbar";
import { Footer } from "../../../components/Footer/Footer";
import { Banner } from "../../../components/Banner/Banner";
import topImage from "../../../assets/images/BannerTop.png";

export const RecreationWrite = () => {
    const BOARD_URL = process.env.REACT_APP_BOARD_API_URL || 'http://localhost:5001';
    const navigate = useNavigate();
    
    const [month, setMonth] = useState(""); 
    const [file, setFile] = useState(null);
    const [preview, setPreview] = useState(null);

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            setPreview(URL.createObjectURL(selectedFile));
        }
    };

    const handleSubmit = async () => {
        if (!month || !file) {
            // [수정] 멘트 수정
            alert("월(Month)과 활동 이미지를 모두 등록해주세요.");
            return;
        }

        const formData = new FormData();
        formData.append('month', month);
        formData.append('image', file);

        const token = localStorage.getItem('token');
        try {
            // 🚨 [핵심 수정] 주소를 /meals가 아니라 /recreations로 변경해야 합니다!
            const res = await fetch(`${BOARD_URL}/recreations`, {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${token}` },
                body: formData
            });

            if (res.ok) {
                alert("활동이 등록되었습니다.");
                navigate('/recreation'); 
            } else {
                const data = await res.json();
                alert(`등록 실패: ${data.message || "오류"}`);
            }
        } catch (err) {
            alert("서버 오류 발생");
        }
    };

    return (
        <>
            <Navbar />
            <Banner imageSrc={topImage} title="활동 등록" />
            
            <div className="page" style={{ maxWidth: '600px', margin: '50px auto', padding: '20px' }}>
                <div style={{ marginBottom: '20px' }}>
                    <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '10px' }}>해당 월 (예: 8월)</label>
                    <input 
                        type="text" 
                        value={month} 
                        onChange={(e) => setMonth(e.target.value)}
                        placeholder="예) 8월"
                        style={{ width: '100%', padding: '10px', fontSize: '16px' }}
                    />
                </div>

                <div style={{ marginBottom: '1.5vw', paddingLeft: '2.3vw' }}>
                    <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '10px' }}>활동 이미지</label>
                    <input type="file" accept="image/*" onChange={handleFileChange} />
                </div>

                {preview && (
                    <div style={{ marginBottom: '20px', textAlign: 'center' }}>
                        <img src={preview} alt="미리보기" style={{ maxWidth: '100%', maxHeight: '300px' }} />
                    </div>
                )}

                <div style={{ textAlign: 'center', marginTop: '30px' }}>
                    <button onClick={handleSubmit} style={{ padding: '10px 30px', backgroundColor: '#898989', color: 'white', border: 'solid 2px #898989', cursor: 'pointer', fontSize: '1vw', borderRadius: '1vw' }}>
                        등록하기
                    </button>
                    {/* [수정] 취소 버튼 경로 수정 (/meal -> /recreation) */}
                    <button onClick={() => navigate('/recreation')} style={{ padding: '10px 30px', marginLeft: '10px', cursor: 'pointer',border: 'solid 2px #898989', borderRadius: '1vw', fontSize:'1vw', color:'#515151ff', backgroundColor: '#fff'     }}>
                        취소
                    </button>
                </div>
            </div>
            <Footer />
        </>
    );
};